import { TexteSeo } from '@components/texte-seo/models';
import { textSeoMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const texteSeoMock = (background: 'gray' | 'white' = 'white'): Block<TexteSeo> => ({
  type: 'texte-seo',
  data: textSeoMock(background),
});
